export default __webpack_public_path__ + "6791740ed324b630f975a17b139e708c.png";